export default {"src":"/_next/static/media/link-icon.c9dbda0e.svg","height":12,"width":12};